import { Video as PrimitiveVideo } from '@basehub/tiptap-api-utils'

export const Video = PrimitiveVideo.extend({
  addNodeView() {
    return ({ node }) => {
      const video = document.createElement('video')
      video.classList.add('video-loading')
      video.onload = () => video.classList.remove('video-loading')
      video.src = node.attrs.src
      video.controls = true
      video.style.cursor = 'pointer'

      if (node.attrs.width && node.attrs.height) {
        video.style.aspectRatio = `${node.attrs.width} / ${node.attrs.height}`
        video.width = node.attrs.width
        video.height = node.attrs.height
      } else {
        video.style.width = '100%'
      }

      return { dom: video }
    }
  },
})
